import { useEffect } from 'react'

export function useRemoveMagicKey() {
  useEffect(() => {
    const searchParam = new URLSearchParams(window.location.search)
    const uri = searchParam.get('uri')

    if (uri) {
      localStorage.removeItem('@appkit-wallet/EMAIL_LOGIN_USED_KEY')
    }
  }, [])
}
